import styles from './index.module.scss';

export type FileIconProps = {
  extension: string;
  color?: 'green' | 'blue' | 'red' | 'yellow' | 'orange' | 'purple' | 'teal' | 'navy';
};

export default function FileIcon({ extension, color }: FileIconProps) {
  return (
    <div className={styles.wrapper} data-color={color}>
      <div className={styles.icon}>
        <div className={styles.content}>
          <span className={styles.extension}>{extension}</span>
        </div>
      </div>
    </div>
  );
}
